import { truncateWithEllipsis } from '@smartfm/container/utils/strings';
import { Button } from '@smartfm/ui/components/Button';
import {
  SearchMenu,
  type SearchMenuProps,
} from '@smartfm/ui/components/SearchMenu';
import './styles.scss';
import { Box } from '@smartfm/ui/components/Box';
import { Icon } from '@smartfm/ui/components/Icon';

export interface ClientSelectorProps
  extends Omit<
    SearchMenuProps,
    | 'values'
    | 'triggerElement'
    | 'trailingHeaderElement'
    | 'stickyListItemProps'
    | 'width'
    | 'itemHeight'
    | 'itemsMap'
    | 'source'
  > {
  itemsMap: Record<
    keyof SearchMenuProps['itemsMap'],
    Omit<SearchMenuProps['itemsMap']['string'], 'secondaryText'>
  >;
  defaultLabel: string;
  value?: string;
}

export function ClientSelector(props: ClientSelectorProps) {
  const {
    value = '',
    itemsMap,
    itemsOrder,
    defaultLabel,
    onValueChange,
    favoriteItems,
    defaultItem,
    ...otherProps
  } = props;
  const { label } = itemsMap[value] || { label: defaultLabel };

  function getStickyListItemsProps() {
    if (!defaultItem) return;
    const item = itemsMap[defaultItem];
    if (!item) return;
    const { label, ...otherItemProps } = item;

    const formattedLabel = label && truncateWithEllipsis(label, 40);

    return {
      ...otherItemProps,
      isActive: value === defaultItem,
      onClick: () => onValueChange(defaultItem),
      label: formattedLabel,
      trailingTemplate: (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 36,
            height: 36,
            flexShrink: 0,
          }}
        >
          <Icon
            icon='home'
            fontsizeInRem={1.25}
          />
        </Box>
      ),
    };
  }

  return (
    <SearchMenu
      // Due to the way the EmeraldMenu component is implemented,
      // The key is required to force the component to re-render
      // To close the menu each time the value changes
      key={value}
      width={322}
      itemHeight={50}
      triggerElement={
        <Button
          icon={
            defaultItem === value
              ? 'home'
              : favoriteItems.includes(value)
                ? 'star'
                : undefined
          }
          rightIcon='arrow_drop_down'
          size='Small'
          type='Light'
          className='client-selector__trigger'
          title={label}
          label={truncateWithEllipsis(label, 30)}
        />
      }
      stickyListItemProps={getStickyListItemsProps()}
      values={[value]}
      itemsMap={itemsMap}
      favoriteItems={favoriteItems}
      onValueChange={onValueChange}
      defaultItem={defaultItem}
      itemsOrder={itemsOrder}
      {...otherProps}
    />
  );
}
